export default "__VITE_ASSET__995c88f7__"